import React from "react";
import {
  Box,
  Typography,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Button,
  Divider,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  FileCopy as FileCopyIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CoachData from "../../../../../data/CoachData";

import Mighty45MobileStoreLinks from "../../../../../components/Mighty45MobileStoreLinks";

const StyledCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
  height: "100%",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(5),
  padding: theme.spacing(1, 2),
  textTransform: "none",
  fontWeight: 600,
  margin: theme.spacing(0, 0.5),
}));

const CodeDisplay = styled(Typography)(({ theme }) => ({
  fontFamily: "monospace",
  fontWeight: "bold",
  fontSize: "1.2rem",
  padding: theme.spacing(0.75, 1.5),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  marginRight: theme.spacing(1),
}));

const CoachConnectCodeCard = ({ coach }) => {
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  if (!coach) {
    return null;
  }

  const handleCopy = (type) => {
    setSnackbar({
      open: true,
      message: `${type} copied to clipboard!`,
      severity: "success",
    });
  };

  const handleNewCode = () => {
    CoachData.resetConnectCode(coach.uid);
    setSnackbar({
      open: true,
      message: "New code generated!",
      severity: "success",
    });
  };

  return (
    <>
      <StyledCard className="coach-summary-card">
        <CardHeader
          title="Connect Code"
          subheader="Share this code during coach signup/register in the Mighty45 mobile app."
        />
        <Divider />
        <CardContent className="fade-in-animation">
          <Box sx={{ mb: 3 }}>
            {coach.connectCode ? (
              <>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <CodeDisplay variant="body1">{coach.connectCode}</CodeDisplay>

                  <CopyToClipboard
                    text={coach.connectCode}
                    onCopy={() => handleCopy("Code")}
                  >
                    <IconButton
                      size="small"
                      aria-label="Copy code"
                      disableRipple
                      disableFocusRipple
                    >
                      <FileCopyIcon />
                    </IconButton>
                  </CopyToClipboard>
                </Box>

                <Mighty45MobileStoreLinks />
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Press &ldquo;Get New Code&rdquo; to generate a connect code
              </Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <ActionButton
              variant="contained"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={handleNewCode}
            >
              Get New Code
            </ActionButton>
          </Box>
        </CardContent>
      </StyledCard>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CoachConnectCodeCard;
